import * as React from "react";
import styled from "styled-components";
import { useCallback, useMemo } from "react";
import URI from "urijs";
import IconButton from "components/common/IconButton";
import Icon from "components/common/Icon";
import { LinkContainer } from "components/common";
import SearchLink from "views/logic/search/SearchLink";
import Store from "logic/local-storage/Store";
import { createElasticsearchQueryString } from "views/logic/queries/Query";
import generateId from "logic/generateId";
const NeutralLink = styled.a`
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  color: inherit;
  text-decoration: none;

  &:hover {
    text-decoration: none;
  }

  &:visited {
    color: inherit;
  }
`;
const StyledIcon = styled(Icon)`
  margin-left: 6px;
`;
const buildSearchLink = (sessionId, timerange, queryString, streams, streamCategories, parameters, filters) => {
  let searchLink = SearchLink.builder().query(createElasticsearchQueryString(queryString)).timerange(timerange).streams(streams).streamCategories(streamCategories).build().toURL();
  if ((parameters == null ? void 0 : parameters.size) || (filters == null ? void 0 : filters.size)) {
    searchLink = new URI(searchLink).setSearch("session-id", sessionId).toString();
  }
  return searchLink;
};
const iconName = "play_arrow";
export const ReplaySearchButtonComponent = ({
  searchLink,
  children = void 0,
  onClick = void 0,
  component: Component = NeutralLink,
  newTab = false
}) => {
  const title = "Replay search";
  const newTabProps = newTab ? { href: searchLink, target: "_blank", rel: "noopener noreferrer" } : {};
  const button = children ? /* @__PURE__ */ React.createElement(Component, { title, onClick, ...newTabProps }, children, " ", /* @__PURE__ */ React.createElement(StyledIcon, { name: iconName })) : /* @__PURE__ */ React.createElement(IconButton, { name: iconName, title, onClick, ...newTabProps });
  return newTab ? button : /* @__PURE__ */ React.createElement(LinkContainer, { to: searchLink }, button);
};
const ReplaySearchButton = ({
  queryString = void 0,
  timerange = void 0,
  streams = void 0,
  streamCategories = void 0,
  parameters = void 0,
  filters = void 0,
  parameterBindings = void 0,
  newTab = false
}) => {
  const sessionId = useMemo(() => `replay-search-${generateId()}`, []);
  const searchLink = buildSearchLink(sessionId, timerange, queryString, streams, streamCategories, parameters, filters);
  const onReplaySearch = useCallback(() => {
    var _a;
    if ((parameters == null ? void 0 : parameters.size) || (filters == null ? void 0 : filters.size)) {
      Store.set(
        sessionId,
        JSON.stringify({
          parameters,
          parameterBindings,
          filters: (_a = filters == null ? void 0 : filters.toArray()) != null ? _a : []
        })
      );
    }
  }, [sessionId, parameters, parameterBindings, filters]);
  return /* @__PURE__ */ React.createElement(ReplaySearchButtonComponent, { searchLink, onClick: onReplaySearch, newTab });
};
export default ReplaySearchButton;
